// extracted by mini-css-extract-plugin
module.exports = {"componentsButton":"styles_componentsButton__AxJIv","scaleDrew":"styles_scaleDrew__1VK5B"};